module.exports = __webpack_public_path__ + "img/Deak_580x440.f12e383e.png";